module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.7e16c473.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-SemiBoldItalic.woff
// module id = 705
// module chunks = 21